import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IReportsByJobData {
  start_date: string;
  end_date: string;
  job_ids: string;
  task_id: string;
  all_jobs: boolean;
  timesheet_ids?: string[];
  user_id?: string[];
}

const fetchReportsByJob = (postData: IReportsByJobData) => {
  return http().lpost(endpoints.reports.byJob, postData);
};

export function useFetchReportsByJob() {
  return useMutation({ mutationFn: fetchReportsByJob });
}
